<div class="card">
  <div class="card-body">
    @if (parent) {
      <app-content [parent]="parent" [location]="eContentLocation.Above"></app-content>
      <app-content [parent]="parent" [location]="eContentLocation.Content"></app-content>
      <app-content [parent]="parent" [location]="eContentLocation.Below"></app-content>
    }
  </div>
</div>
